import { Divider, Drawer, Space, Button, Radio } from "antd";
import React  from "react";
import moment from "moment";
import ColourPicker from "../../../globals/styles/ColourPicker";
import { usePrefs } from "../../../utils/Prefs";
import { apiCall } from "../../../utils/Api";
import { getColor } from "../../../utils/ConvertCSS";
import { useTemplate } from "../../../utils/Template";

export default function Features(props) {

    const [prefs, setPrefs] = usePrefs();
    const [template, ] = useTemplate(); 

    const { edit = false, close = () => { } } = props;

    // set componenet specific
    const setData = (_data) => {
        setPrefs({ ...prefs, "features": { ...prefs.features, "data": _data } })
    }

    // set componenet agnostic
    const setContent = (_key, _data) => {
        setPrefs({ ...prefs, "features": { ...prefs.features, [_key]: _data } })
    }

    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = prefs.nav_bar;

    // Component specific
    const {
        background_colour = 0,
    } = data;

    // Re-fetch old and update ui element
    const onCancel = () => {
        apiCall("site_content/getSettings", {}, (_status, _result) => {
            if (_status) {
                if (_result) {
                    if (_result.hasOwnProperty("features")) {
                        setPrefs({ ...prefs, "features": _result.features })
                    }
                }
            }
        })
        close();
    }

    const drawRender = () => {
        return(<div style={{"backgroundColor" : getColor(background_colour, template)}}></div>)
    }

    const drawForm = () => {
        return (
            <>
                <div style={{ "fontSize": "18px", "lineHeight": "18px" }}><strong>{name}</strong></div>
                {(date_changed && <em style={{ "fontSize": "12px" }}>Last updated {moment(date_changed * 1000).format("MMM Do, YYYY h:mm a")}</em>)}
                <div className="shim" /><div className="shim" />
                <div style={{ "display": "flex", "justifyContent": "stretch" }}>
                    <Button block size="small" type="primary"><small>Save Changes</small></Button>
                    <div style={{ "width": "10px" }}></div>
                    <Space>
                        <Button onClick={() => onCancel()} size="small" type="default"><small>Cancel</small></Button>
                    </Space>
                </div>
                <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>
                {/* CONTAINER */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LAYOUT</Divider>
                <div className="float-flex">
                    <div></div>
                    <Space>
                        <Radio.Group value={container} onChange={(e) => setContent("container", e.target.value)} >
                            <Radio value={false}><small>100% of the screen width</small></Radio>
                            <Radio value={true}><small>Container width (max 1248px)</small></Radio>
                        </Radio.Group>
                    </Space>
                </div>
                <div className="shim" /><div className="shim" />
                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_none allow_gradient value={background_colour} onChange={(e) => setData({ ...data, "background_colour": e })} />
                <div className="shim" /> <div className="shim" />
            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX" : "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )

}